import type { MemberBucket } from "../shared/types";

export const BUCKET_LABELS: Record<MemberBucket, string> = {
  paid: "Paid",
  whitelisted: "Whitelisted",
  expired_access: "Access expired",
  active_unpaid: "Active · unpaid",
  inactive_unpaid: "Inactive · unpaid",
  unknown_unpaid: "Activity unknown",
  grace_unpaid: "Linking grace",
  exempt_admin: "Exempt admin",
  not_in_group: "Not in group",
};
